///include /assets/js/app/s/catalogue.js
///include /assets/js/app/p/sbproduct/all.js
///include /assets/js/app/s/sdomain-store.js
///include /assets/js/app/p/spayment-item.js
///include /assets/js/app/s/basket.js
///include /assets/js/app/p/brand.js

"use strict"

class SDomainRequiredPage {
    init(){
        this.view = new Vue({
            el: "#domain-required",
            delimiters: ["[[", "]]"],
            data() {
                const vue = this
                return {
                    /** @type {SBasket} */
                    //@ts-ignore
                    basket: AnyBasket.inst,
                    brand: window["brand"],
                    catalogue: UserCatalogue.inst,
                    domainSearchText: "",
                    search: null,
                    searchQuick: null,
                    domainStore: AnyDomainStore.inst,
                    domainType: "select",
                    domains: null,
                    errors: {
                        noProductFound: false
                    },
                    option: "register",
                    periodMonths: null,
                    /** @type {?string} */
                    productCode: null,
                    savedDomainProducts: [],
                    selectingDomain: "",
                    settings: SharedSettings.inst,
                    submitInprogress: false,
                    get domainOptions() {
                        var domainlist = this.domains && this.domains.map(d => ({
                            text: d.name,
                            id: d.name,
                        })).sort( (a,b) => {
                            return a.text.localeCompare(b.text)
                        });
                        if( domainlist.length == 0 ){
                            this.domainType = 'type';
                        }
                        return domainlist;
                    },
                    get hasDomainProducts() {
                        if(typeof SBDomainProduct != "undefined" && this.catalogue.products){
                            return this.catalogue.products && this.catalogue.products.some(p => p instanceof SBDomainProduct);
                        } else {
                            return null;
                        }
                    },
                    get hasTransferProducts() {
                        if( typeof SBDomainProduct != "undefined" && this.catalogue.products ){
                            return this.catalogue.products && this.catalogue.products.some(p => p instanceof SBDomainProduct && p.offerTransfer );
                        } else {
                            return null;
                        }
                    },
                    get hasUnhostedDomains() {
                        return this.domains && this.domains.length;
                    },
                    get loading() {
                        return !(
                            this.brand &&
                            this.catalogue.products &&
                            this.catalogue.isOpen !== null
                        )
                    },
                    get loggedIn() {
                        return !!this.settings.authenticatedUser;
                    },
                    get product() {
                        if(this.catalogue.products && this.productCode) {
                            /**
                             * @type {?SBHostingProduct}
                             */
                            //@ts-ignore
                            const product = this.catalogue.products.find(
                                p => p.code == this.productCode
                            )
                            if(product) {
                                return product
                            } else {
                                this.errors.noProductFound = true
                                return null
                            }
                        } else {
                            return null
                        }
                    },

                    async add_only_hosting(with_domian = true) {
                        if(this.product && !this.submitInprogress) {
                            try {
                                this.submitInprogress = true
                                // Honour the forced billing period (`t`) for both the
                                // with-domain and "choose a domain later" paths.
                                var price;
                                if( this.periodMonths ){
                                    price = this.product.pricing.find( p => p.periodMonths == this.periodMonths );
                                } else {
                                    price = this.product.pricing.sort(
                                        (a, b) => +a - +b
                                    )[0];
                                }

                                if( !price ){
                                    alert("No price found");
                                    return;
                                }

                                const pic = PaymentItemCollection.inst
                                if(with_domian) {
                                    const basketItem = await this.product.basketItem(
                                        price,
                                        this.selectingDomain
                                    )

                                    if(basketItem.serviceConfiguration === 'object') {
                                        Object.assign(basketItem.serviceConfiguration, { name: this.selectingDomain })
                                    } else {
                                        basketItem.serviceConfiguration = {
                                            name: this.selectingDomain
                                        }
                                    }

                                    await this.basket.addWithInfo(
                                        {
                                            paymentItemCountries: await pic.preloadSingle("countriesFlat"),
                                        },
                                        basketItem
                                    )
                                } else {
                                    await this.basket.addWithInfo(
                                        {
                                            paymentItemCountries: await pic.preloadSingle("countriesFlat"),
                                        },
                                        await this.product.basketItem(
                                            price
                                        )
                                    )
                                }
                                setTimeout(() => {
                                    if(this.loggedIn) {
                                        location.href = "/checkout"
                                    } else {
                                        location.href = "/basket-summary-login?r=/checkout"
                                    }
                                }, 300) // Work around HTTP2 offloading x firefox
                            } finally {
                                this.submitInprogress = false;
                            }
                        }
                    },
                    searchForDomain() {
                        location.href =
                            "/domain-search?" +
                            $.param({domain: this.domainSearchText})
                    },
                    async initDomains() {
                        try {
                            const packages = await $.ajax({
                                method: "get",
                                url: `/a/package`,
                                data: {
                                    fields: ["names"],
                                },
                            })
                            const domains_in_packages = {}
                            for(const p of packages) {
                                for(const n of p.names) {
                                    domains_in_packages[n.toLowerCase()] =
                                        true
                                }
                            }
                            const domains = await $.ajax(`/a/domain`)
                            this.domains = domains.filter(
                                domain => !domains_in_packages[
                                    domain.name.toLowerCase()
                                ]
                            )
                        } catch(e) {
                            // Do nothing here, user most likely not logged in
                        }
                    },
                    /**
                     *
                     * @param {{name: string}} domain
                     * @param {*} prop
                     */
                    async toggle_domain_basket_wrapper(domain, prop) {
                        if(this.product && !this.submitInprogress) {
                            var price;
                            this.submitInprogress = true
                            const c = vue.$children[0]
                            //@ts-ignore
                            await c.toggle_domain_basket(domain, prop)
                            if( this.periodMonths ){
                                price = this.product.pricing.find( p => p.periodMonths == this.periodMonths );
                            } else {
                                price = this.product.pricing.sort(
                                    (a, b) => +a - +b
                                )[0];
                            }

                            if( !price ){
                                alert("No price found");
                                return;
                            }

                            const pic = PaymentItemCollection.inst
                            const basketItem = await this.product.basketItem(
                                price,
                                domain.name
                            )

                            if(basketItem.serviceConfiguration === 'object') {
                                Object.assign(basketItem.serviceConfiguration, { name: domain.name })
                            } else {
                                basketItem.serviceConfiguration = {
                                    name: domain.name
                                }
                            }

                            await this.basket.addWithInfo(
                                {
                                    paymentItemCountries:
                                        await pic.preloadSingle("countriesFlat"),
                                },
                                basketItem
                            )
                            setTimeout(() => {
                                if(this.loggedIn) {
                                    location.href = "/checkout"
                                } else {
                                    location.href = "/basket-summary-login?r=/checkout"
                                }
                            }, 300) // Work around HTTP2 offloading x firefox
                        }
                    },
                }
            },
            computed: {
                displaySearch() {
                    return (this.option === "register") || (this.option === "transfer") ? true : false
                },
                hasDomainsInCatalog() {
                    if(
                        this.catalogue &&
                        this.catalogue.nonHidddenProducts &&
                        this.catalogue.nonHidddenProducts.length
                    ) {
                        const domains = this.catalogue.nonHidddenProducts.filter(d => {
                            return d instanceof SBDomainProduct
                        })

                        return !!domains.length
                    }

                    return false
                }
            },
            methods: {
                dispatchSearchQuick(e) {
                    this.searchQuick = e
                },
                dispatchSearch(e) {
                    this.search = e
                }
            },
            watch: {
                hasDomainProducts(v) {
                    if( !v ){
                        this.option = "existing";
                    }
                },

                hasTransferProducts(v) {
                    if( !v && !this.hasDomainProducts ){
                        this.option = "existing";
                    }
                },

                loading(v) {
                    if(!v) {
                        Vue.nextTick( () => {
                            $( ".page-loaded-content" ).fadeTo(200,1, function() {});
                        });
                    }
                }
            },
            async mounted() {
                const urlParam = new URLSearchParams(location.search);
                const requestedCurrency = (urlParam.get("currency") || "").toUpperCase();
                var urlCode  = urlParam.get("p");
                if( urlCode && urlCode.match(/^package:/) ){
                    // We are going to guess the v2 product
                    var p = urlCode.split(":")[1];
                    await this.catalogue.preloadSingle("products");
                    for(const product of this.catalogue.products){
                        if( product instanceof SBStackUserPackageAllowanceProduct ){
                            var parts = product.typeRef.split("-");
                            if( parts[0] == p && parts[1] == 1 ){
                                urlCode = product.typeRef;
                            }
                        }
                    }
                }
                this.productCode = 'stack_user_package_allowance:'+urlCode;
                this.periodMonths = urlParam.get("t")
                if(!this.productCode ){
                    this.errors.noProductFound = true
                }
                this.catalogue.assertExists()
                await this.catalogue.preloadSingle("config")

                if(requestedCurrency) {
                    const supportedCurrencies =
                        this.catalogue.config &&
                        this.catalogue.config.supportedCurrencies;
                    const isSupportedCurrency =
                        !!(
                            supportedCurrencies &&
                            Object.prototype.hasOwnProperty.call(
                                supportedCurrencies,
                                requestedCurrency
                            ) &&
                            Catalogue.currencies[requestedCurrency]
                        );
                    // Compare against the server-side session currency (config),
                    // not `this.catalogue.currency` which may not be populated yet.
                    const currentCurrency =
                        this.catalogue.config && this.catalogue.config.currency;

                    if(isSupportedCurrency && currentCurrency !== requestedCurrency) {
                        let lockedCurrency = false;
                        if(this.settings && this.settings.authenticatedUser) {
                            try {
                                lockedCurrency = await $.ajax(`/a/locked_selected_currency`);
                            } catch(e) {
                                // If lock state cannot be determined, fail closed for safety.
                                lockedCurrency = true;
                            }
                        }

                        if(!lockedCurrency) {
                            // Switch the basket currency server-side, then reload so
                            // the entire catalogue (products, pricing, config) is
                            // re-fetched in the new currency. An in-page property
                            // reload races against cached catalogueConfig and stale
                            // pricing objects, leaving quotedPriceFull in the old
                            // currency. Mirrors the header/footer currency switcher.
                            // The `?currency=` query string persists across the
                            // reload and the guard above prevents a reload loop.
                            await this.basket.changeCurrency(requestedCurrency);
                            location.reload();
                            return;
                        }
                    }
                }

                await this.catalogue.preloadSingle("currencySymbol")
                await this.domainStore.preloadSingle("domainCategory")
                DRStatus.currencySymbol = UserCatalogue.inst.currencySymbol
                var discountCode = urlParam.get("discountCode")
                if( discountCode ){
                    this.basket.addDiscountCode(discountCode);
                }
                this.initDomains();
            },
            components: {
                domainSearch: DomainSearch,
                "vue-select": VueSelect,
            }
        })
    }
}
